import React, { useState } from 'react';
import { HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi';

/**
 * Plain <input> with a show/hide (eye) toggle — same pattern as the org admin
 * login (pages/Auth/Login.jsx). Renders a native input so it inherits the
 * superadmin `.form-group input` styles; all input props are passed through.
 */
const PasswordInput = ({ wrapperClassName = '', wrapperStyle, style, disabled, ...inputProps }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className={`password-input ${wrapperClassName}`.trim()}
      style={{ position: 'relative', width: '100%', ...wrapperStyle }}
    >
      <input
        {...inputProps}
        disabled={disabled}
        type={visible ? 'text' : 'password'}
        style={{ width: '100%', paddingRight: '2.75rem', ...style }}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        disabled={disabled}
        aria-label={visible ? 'Hide password' : 'Show password'}
        title={visible ? 'Hide password' : 'Show password'}
        style={{
          position: 'absolute',
          top: '50%',
          right: '0.75rem',
          transform: 'translateY(-50%)',
          display: 'flex',
          alignItems: 'center',
          padding: 0,
          margin: 0,
          border: 'none',
          background: 'transparent',
          color: '#9ca3af',
          cursor: disabled ? 'not-allowed' : 'pointer',
          lineHeight: 0,
        }}
      >
        {visible ? <HiOutlineEyeOff size={20} /> : <HiOutlineEye size={20} />}
      </button>
    </div>
  );
};

export default PasswordInput;
